import { isNumber } from "lodash";
import { forwardRef, useMemo } from "react";
import Dialog from "./../../components/common/Dialog";
import Button from "./../../components/v6/Button";

const Detail = forwardRef((props, ref) => {
  const { data, onRedeem, loading } = props;

  const handleRedeem = () => {
    ref.current.close();
    if (onRedeem && data) onRedeem(data);
  };

  const renderDiscountDescription = () => {
    return (
      <div className="flex flex-col gap-5">
        <div
          className="[&>p]:text-sm [&>p]:leading-[17px]"
          dangerouslySetInnerHTML={{ __html: data?.reward?.description }}
        />
      </div>
    );
  };

  const reward = useMemo(() => {
    if (!data?.reward) return "";
    const { reward } = data;

    const redemption = `${reward.redemptions[0].quantity} stickers for`;
    const rewardQuantity = isNumber(reward.reward_quantity) ? reward.reward_quantity : "";

    switch (reward.type) {
      case "DISCOUNT":
        const discountTitle = `${reward.discount_percentage}% discount at ${reward.discount_at}`;
        return `${redemption} ${discountTitle}`;
      case "COIN":
        const coinTitle = `${reward.token} ${reward.token > 1 ? "coins" : "coin"}`;
        return `${redemption} ${coinTitle}`;
      case "XP":
        const xpTitle = `${reward.xp} XP`;
        return `${redemption} ${xpTitle}`;
      default:
        return `${redemption} ${rewardQuantity} ${reward?.reward_name}`;
    }
  }, [data]);

  return (
    <Dialog ref={ref}>
      <div className="flex flex-col gap-[30px]">
        <div>
          <p className="text-2xl leading-6 font-bold text-primary mb-3 pr-10">{data?.name}</p>
          <p className="text-sm w-fit font-bold text-white bg-primary px-3 rounded-xl">
            {data?.total_available} Stickers
          </p>
        </div>
        <div className="flex justify-center items-center gap-6">
          {Array.from({ length: 1 }, (_, index) => (
            <div
              key={index}
              className={`flex size-[60px] items-center justify-center rounded-full shadow-badge relative`}
              style={{ background: data.background || "#ECEEFF" }}
            >
              <div className="rounded-full size-[60px]">
                <img
                  className="size-full object-cover rounded-full"
                  src={
                    data?.image_data
                      ? `${process.env.REACT_APP_URL_IMAGE}/${data?.image_data?.file_path}`
                      : "/images/brand.jpg"
                  }
                  alt=""
                />
              </div>
            </div>
          ))}
        </div>
        <p className="text-center text-2xl leading-7 font-bold text-primary">{reward}</p>
        <p className="text-center text-lg leading-5">
          {["COIN", "XP"].includes(data?.reward?.type) ? "By Rally AI" : `By ${data?.business_name}`}
        </p>
        {data?.reward?.type !== "COIN" && renderDiscountDescription()}
        <Button
          disabled={loading || data?.total_available < data?.reward?.redemptions[0].quantity}
          handleClick={handleRedeem}
        >
          Redeem
        </Button>
      </div>
    </Dialog>
  );
});

Detail.displayName = "Detail";

export default Detail;
